import { Injectable, Pipe, PipeTransform } from '@angular/core';

/*
  Generated class for the TipoBancoFilter pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'tipobancofilter'
})
@Injectable()
export class TipoBancoFilter implements PipeTransform {
  transform(item: any, args: any[]): any {
    if (args != []) {
      return args.filter((arg) => arg.id == item).map((objetoFiltrado) => {
        return objetoFiltrado.nome;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tipo-banco-filter.ts